import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import Edgecruds from '../../modules/ctx-services/Edgecruds'
import { useAppSelector } from '../../../redux/hooks'
import { useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'

const Edge: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  // useEffect para verificar si el permiso está disponible
  useEffect(() => {
    // Verificar si ya estamos en la ruta correcta y tenemos el permiso necesario
    if (location.pathname.startsWith('/cloudConnectivity') && ListaPermisosTenant.includes('CC.View')) {
      // Si estamos en la ruta '/cloudConnectivity' y tenemos el permiso 'CC.View', no hacemos nada más
      setLoading(false);
      return;
    }

    const delay = setTimeout(() => {
      const hasPermissionCCView = ListaPermisosTenant.includes('CC.View');
      const hasPermissionCTXR = ListaPermisosTenant.includes('CTXR.GeneralStatus');
      setLoading(false); // Cambiar estado cuando se hayan validado los permisos

      // Redirigir solo si no estamos en la ruta adecuada o no tenemos permisos
      if (!hasPermissionCCView && !hasPermissionCTXR) {
        // Si no tiene permisos de 'CC.View' ni 'CTXR.GeneralStatus', redirigimos al dashboard
        if (location.pathname !== '/dashboard/status') {
          navigate('/dashboard/status');
        }
      } else if (hasPermissionCCView && location.pathname !== '/cloudConnectivity') {
        // Si tiene permiso de 'CC.View' y no estamos en la ruta '/cloudConnectivity', redirigir
        navigate('/cloudConnectivity');
      } else if (hasPermissionCTXR && location.pathname !== '/CTX-R/status') {
        // Si tiene permiso de 'CTXR.GeneralStatus' y no estamos en la ruta '/CTX-R/status', redirigir
        navigate('/CTX-R/status');
      }
    }, 1000); // Retraso de 1 segundo

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate, location.pathname]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    )
  }

  return (
    <>
      <Routes>
        <Route path="/*" element={<Edgecruds />} />
      </Routes>
    </>
  )
}

export { Edge }
